import React from "react";
import PropTypes from "prop-types";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@material-ui/core";

// context
import { useUserDispatch } from "../../context/UserContext";

const useStyles = makeStyles(theme =>
  createStyles({
    dialogPaper: {
      padding: theme.spacing(1),
    },
    dialogTitle: {
      ...theme.typography.subtitle1,
      fontWeight: 500,
    },
    dialogDescription: {
      ...theme.typography.smallCaption,
    },
    dialogButton: {
      ...theme.typography.caption,
      fontWeight: 500,
      width: 56,
      height: 28,
    },
    dialogSubmitButton: {
      ...theme.typography.caption,
      fontWeight: 500,
      color: "white",
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      width: 56,
      height: 28,
      padding: "4px 16px",
      borderRadius: 20,
    },
  }),
);

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const VideoQuotaExceedDialog = props => {
  const classes = useStyles();
  const { open, setOpen } = props;

  const handleDialogClose = () => {
    if (setOpen) {
      setOpen(false);
    }
  };

  return (
    <div>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleDialogClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle
          id='alert-dialog-slide-title'
          className={classes.dialogTitle}
        >
          {"授權數量不足"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id='alert-dialog-slide-description'
            className={classes.dialogDescription}
          >
            目前登入的裝置/使用者數量已超過此帳號的授權數量，故無法播放影片。請登出其他裝置，或請稍後再試。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <StyledButton variant='text' onClick={handleDialogClose}>
          取消
          </StyledButton>
          <StyledButton variant='default' onClick={handleDialogClose}>
            確定
          </StyledButton> */}
          <Button
            onClick={handleDialogClose}
            color='primary'
            className={classes.dialogButton}
          >
            取消
          </Button>
          <Button
            onClick={handleDialogClose}
            color='primary'
            className={classes.dialogSubmitButton}
          >
            確定
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

VideoQuotaExceedDialog.defaultProps = {};

VideoQuotaExceedDialog.propsTypes = {};

export default VideoQuotaExceedDialog;
